import { Routes, Route, useNavigate } from "react-router-dom";
import { builder } from "@builder.io/react";
import MainLayout from "../layout/MainRoutes";
import AuthLayout from "../layout/AuthRoutes";
import PageHome from "pages/homePage/HomePage";
import PageSignUp from "pages/PageSignUp/PageSignUp";
import PageLogin from "pages/PageLogin/PageLogin";
import ProductDetailPage from "pages/products/ProductDetailPage";
import CartPage from "pages/cart/CartPage";
import ProductListing from "pages/products/ProductListing";
import OccasionalGiftingPage from "pages/products/OccasionalGiftingPage";
import AccountForgotPass from "containers/AccountManagement/AccountForgotPass";
import CatchAllRoute from "./builder";
import PageAbout from "pages/PageAbout/PageAbout";
import PageResetPassword from "containers/AccountManagement/PageResetPassword";
import VerifyEmail from "containers/email-verification/VerifyEmail";
import MyProfile from "containers/MyProfile/MyProfile";
import DataTable from "components/DashboardFeatures/DataTable";
import CatalogGenerationPage from "pages/Tools/CatalogGenerationPage";
import MockupGeneratorPage from "pages/Tools/MockupGeneratorPage";
import AuthModal from "components/AuthModal/AuthModal";
import CognitoRedirectHandler from "shared/CognitoRedirectHandler/CognitoRedirectHandler";
import TermsOfUsePage from "pages/TermsOfUsePage/TermsOfUsePage";
import PrivacyPolicyPage from "pages/PrivacyPolicyPage/PrivacyPolicyPage";
import ProtectedRoute from "components/ProtectedRoute/ProtectedRoute";
import PageChangePassword from "containers/AccountManagement/PageChangePassword";
import ContactUs from "@/pages/ContactUs/ContactUs";
import VideoModal from "@/components/VideoModal/VideoModal";
import KitsListingPage from "pages/kits/KitsListingPage";
import { useAppDispatch, useAppSelector } from "@/store/hooks/hooks";
import {
  closeAIModal,
  selectAIModalInitialQuery,
  selectAIModalUserId,
  selectIsAIModalOpen,
} from "@/store/slices/aiModalSlice";
import AIConversation from "@/components/AIConversation/AIConversation";
import KitDetailsPage from "@/pages/kits/KitDetailsPage";

builder.init("17a838b7c1b944799e239066672300ff");

const MyRoutes = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isAIModalOpen = useAppSelector(selectIsAIModalOpen);
  const initialQuery = useAppSelector(selectAIModalInitialQuery);
  const userId = useAppSelector(selectAIModalUserId);

  const handleProductsFound = (products: any[]) => {
    navigate("/products", { state: { products } });
  };
  return (
    <>
      <AuthModal />
      <VideoModal />
      {isAIModalOpen && (
        <AIConversation
          initialQuery={initialQuery}
          userId={userId}
          onClose={() => dispatch(closeAIModal())}
          onProductsFound={handleProductsFound}
        />
      )}
      <Routes>
        <Route element={<AuthLayout />}>
          <Route path="/signin" element={<PageLogin />} />
          <Route path="/signup" element={<PageSignUp />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/forgot-password" element={<AccountForgotPass />} />
          <Route path="/reset-password" element={<PageResetPassword />} />
          <Route path="/changePassword" element={<PageChangePassword />} />
        </Route>

        <Route element={<MainLayout />}>
          <Route path="/" element={<PageHome />} />
          <Route path="/about-us" element={<PageAbout />} />
          <Route path="/products" element={<ProductListing />} />
          <Route path="/occasions" element={<OccasionalGiftingPage />} />
          <Route path="/product/:id" element={<ProductDetailPage />} />
          <Route path="/curated-kits" element={<KitsListingPage />} />
          <Route path="/kit/:id" element={<KitDetailsPage />} />
          <Route path="/collection" element={<CartPage />} />
          <Route path="/catalog-dashboard" element={<DataTable />} />
          <Route path="/mockup-dashboard" element={<DataTable />} />
          <Route path="/enquiry-dashboard" element={<DataTable />} />
          <Route path="/terms-of-use" element={<TermsOfUsePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route
            path="/redirect-handler"
            element={<CognitoRedirectHandler />}
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <MyProfile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/catalog-generation-page"
            element={
              <ProtectedRoute>
                <CatalogGenerationPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/mockup-generator/:productId"
            element={<MockupGeneratorPage />}
          />
          <Route path="*" element={<CatchAllRoute />} />
        </Route>
      </Routes>
    </>
  );
};

export default MyRoutes;
